export const accessTokenSaga = (state) => state.loginServiceReducer.accessToken;
export const isAdminSaga = (state) => state.loginServiceReducer.isAdmin;
export const userAuthorizedSaga = (state) => state.loginServiceReducer.userAuthorized;
export const loginResponseSaga = (state) => state.loginServiceReducer.loginResponse;
export const refreshLogicSaga = (state) => state.loginServiceReducer.refreshLogic;
export const usernameSaga = (state) => state.loginServiceReducer.userName;
export const emailAddressSaga = (state) => state.loginServiceReducer.emailId;
export const resetPasswordStatusSaga = (state) => state.loginServiceReducer.resetPasswordStatus;
export const tempPasswordResponseSaga = (state) => state.loginServiceReducer.tempPasswordResponse;
export const confirmForgotPasswordResponseSaga = (state) => state.loginServiceReducer.confirmForgotPasswordResponse;
export const apiCallInProgressSaga = (state) => state.loginServiceReducer.apiCallInProgress;
